/* import __COLOCATED_TEMPLATE__ from './seller-postings-search-location.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

class SellerPostingsSearchLocation extends Component {
  @tracked focused = false;
  @tracked blurredByClick = false;

  get active() {
    return this.focused || this.blurredByClick;
  }

  get formattedAddress() {
    return this.args.location?.formattedAddress || '';
  }

  @action
  focus() {
    this.focused = true;
  }

  @action
  blur() {
    this.focused = false;
  }

  @action
  handleMouseDown() {
    this.blurredByClick = true;
  }

  @action
  onChange(place) {
    if (place.geometry) {
      this.args.onChange(place);
    }

    if (this.blurredByClick) {
      this.blurredByClick = false;
    }
  }
}

export default SellerPostingsSearchLocation;
